import BaseOrder from '../base/order';

export default class Order extends BaseOrder {
}
